/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * 
 * In diesem Dialog werden alle Bilder die einem Produkt zugeordnet wurden
 * in einer Bilder Galerie angezeigt. 
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";

import { useSelector, useDispatch } from 'react-redux';

import * as appActions from "../../../store/actions/appActions";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Counter, Captions, Fullscreen, Thumbnails } from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import * as utils from "../../../basics/utils";
import * as cordova from "../../../basics/cordova";


const ImageGalleryModal = () => {
    const thumbnailsRef = React.useRef(null);

    const app = useSelector((state) => state.app);
    const { path, modalDialog, galleryIndex, galleryImages, appModus } = app;

    const dispatch = useDispatch();
    const { closeModalDialog } = bindActionCreators(appActions, dispatch);

    if (modalDialog.dialog !== 'ImageGalleryModal') return null;

    const getImageUrl = (path, file) => {

        if (appModus === 'Admin') {
            return utils.getURL('product', path, file);

        } else {
            const data = cordova.getImageFromBuffer(path, file);
            return window.URL.createObjectURL(data);
        }
    }

    const onCancel = () => {
        closeModalDialog(); // appAction.js
    }

    const getTagString = (d) => {

        if (d['tags'] === undefined) return null;

        return (
            <div className="w-full text-xl flex items-center justify-center">
                {d.tags.map((d, i) => `#${d} `)}
            </div>
        )
    }

    const images = galleryImages.map((d, i) => { return { src: getImageUrl(d.path, d.file), title: d.file, description: getTagString(d) } })

    return (
        <>
            <Lightbox
                plugins={[Counter, Fullscreen, Captions, Thumbnails]}
                open={true}
                close={() => onCancel()}
                slides={images}
                index={galleryIndex}
                counter={{ container: { style: { top: 0 } } }}
                thumbnails={{ ref: thumbnailsRef }}
                on={{
                    click: () => {
                        (thumbnailsRef.current?.visible
                            ? thumbnailsRef.current?.hide
                            : thumbnailsRef.current?.show)?.();
                    },
                }}
            />
        </>
    );
}

export default ImageGalleryModal;